/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as BorrowerRouteImport } from './routes/borrower'
import { Route as ComplaintsRouteImport } from './routes/complaints'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as EligibilityRouteImport } from './routes/eligibility'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ResponsibleLendingRouteImport } from './routes/responsible-lending'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminBorrowersRouteImport } from './routes/admin.borrowers'
import { Route as AdminLoansRouteImport } from './routes/admin.loans'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AdminMessagesRouteImport } from './routes/admin.messages'
import { Route as BorrowerIndexRouteImport } from './routes/borrower.index'
import { Route as BorrowerApplyRouteImport } from './routes/borrower.apply'
import { Route as BorrowerRepayRouteImport } from './routes/borrower.repay'
import { Route as BorrowerRepaymentCallbackRouteImport } from './routes/borrower.repayment-callback'
import { Route as BorrowerScoreCallbackRouteImport } from './routes/borrower.score-callback'
import { Route as EligibilityEliteRouteImport } from './routes/eligibility.elite'
import { Route as EligibilityExpressRouteImport } from './routes/eligibility.express'
import { Route as EligibilityVerifiedRouteImport } from './routes/eligibility.verified'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const BorrowerRoute = BorrowerRouteImport.update({
  id: '/borrower',
  path: '/borrower',
  getParentRoute: () => rootRouteImport,
} as any)
const ComplaintsRoute = ComplaintsRouteImport.update({
  id: '/complaints',
  path: '/complaints',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiesRoute = CookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const EligibilityRoute = EligibilityRouteImport.update({
  id: '/eligibility',
  path: '/eligibility',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResponsibleLendingRoute = ResponsibleLendingRouteImport.update({
  id: '/responsible-lending',
  path: '/responsible-lending',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBorrowersRoute = AdminBorrowersRouteImport.update({
  id: '/borrowers',
  path: '/borrowers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLoansRoute = AdminLoansRouteImport.update({
  id: '/loans',
  path: '/loans',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMessagesRoute = AdminMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AdminRoute,
} as any)
const BorrowerIndexRoute = BorrowerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BorrowerRoute,
} as any)
const BorrowerApplyRoute = BorrowerApplyRouteImport.update({
  id: '/apply',
  path: '/apply',
  getParentRoute: () => BorrowerRoute,
} as any)
const BorrowerRepayRoute = BorrowerRepayRouteImport.update({
  id: '/repay',
  path: '/repay',
  getParentRoute: () => BorrowerRoute,
} as any)
const BorrowerRepaymentCallbackRoute =
  BorrowerRepaymentCallbackRouteImport.update({
    id: '/repayment-callback',
    path: '/repayment-callback',
    getParentRoute: () => BorrowerRoute,
  } as any)
const BorrowerScoreCallbackRoute = BorrowerScoreCallbackRouteImport.update({
  id: '/score-callback',
  path: '/score-callback',
  getParentRoute: () => BorrowerRoute,
} as any)
const EligibilityEliteRoute = EligibilityEliteRouteImport.update({
  id: '/elite',
  path: '/elite',
  getParentRoute: () => EligibilityRoute,
} as any)
const EligibilityExpressRoute = EligibilityExpressRouteImport.update({
  id: '/express',
  path: '/express',
  getParentRoute: () => EligibilityRoute,
} as any)
const EligibilityVerifiedRoute = EligibilityVerifiedRouteImport.update({
  id: '/verified',
  path: '/verified',
  getParentRoute: () => EligibilityRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/borrower': typeof BorrowerRouteWithChildren
  '/complaints': typeof ComplaintsRoute
  '/cookies': typeof CookiesRoute
  '/eligibility': typeof EligibilityRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/responsible-lending': typeof ResponsibleLendingRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/admin/borrowers': typeof AdminBorrowersRoute
  '/admin/loans': typeof AdminLoansRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/messages': typeof AdminMessagesRoute
  '/borrower/apply': typeof BorrowerApplyRoute
  '/borrower/repay': typeof BorrowerRepayRoute
  '/borrower/repayment-callback': typeof BorrowerRepaymentCallbackRoute
  '/borrower/score-callback': typeof BorrowerScoreCallbackRoute
  '/eligibility/elite': typeof EligibilityEliteRoute
  '/eligibility/express': typeof EligibilityExpressRoute
  '/eligibility/verified': typeof EligibilityVerifiedRoute
  '/admin/': typeof AdminIndexRoute
  '/borrower/': typeof BorrowerIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/complaints': typeof ComplaintsRoute
  '/cookies': typeof CookiesRoute
  '/eligibility': typeof EligibilityRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/responsible-lending': typeof ResponsibleLendingRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/admin/borrowers': typeof AdminBorrowersRoute
  '/admin/loans': typeof AdminLoansRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/messages': typeof AdminMessagesRoute
  '/borrower/apply': typeof BorrowerApplyRoute
  '/borrower/repay': typeof BorrowerRepayRoute
  '/borrower/repayment-callback': typeof BorrowerRepaymentCallbackRoute
  '/borrower/score-callback': typeof BorrowerScoreCallbackRoute
  '/eligibility/elite': typeof EligibilityEliteRoute
  '/eligibility/express': typeof EligibilityExpressRoute
  '/eligibility/verified': typeof EligibilityVerifiedRoute
  '/admin': typeof AdminIndexRoute
  '/borrower': typeof BorrowerIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/borrower': typeof BorrowerRouteWithChildren
  '/complaints': typeof ComplaintsRoute
  '/cookies': typeof CookiesRoute
  '/eligibility': typeof EligibilityRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/responsible-lending': typeof ResponsibleLendingRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/admin/borrowers': typeof AdminBorrowersRoute
  '/admin/loans': typeof AdminLoansRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/messages': typeof AdminMessagesRoute
  '/borrower/apply': typeof BorrowerApplyRoute
  '/borrower/repay': typeof BorrowerRepayRoute
  '/borrower/repayment-callback': typeof BorrowerRepaymentCallbackRoute
  '/borrower/score-callback': typeof BorrowerScoreCallbackRoute
  '/eligibility/elite': typeof EligibilityEliteRoute
  '/eligibility/express': typeof EligibilityExpressRoute
  '/eligibility/verified': typeof EligibilityVerifiedRoute
  '/admin/': typeof AdminIndexRoute
  '/borrower/': typeof BorrowerIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/borrower'
    | '/complaints'
    | '/cookies'
    | '/eligibility'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/reset-password'
    | '/responsible-lending'
    | '/signup'
    | '/terms'
    | '/admin/borrowers'
    | '/admin/loans'
    | '/admin/login'
    | '/admin/messages'
    | '/borrower/apply'
    | '/borrower/repay'
    | '/borrower/repayment-callback'
    | '/borrower/score-callback'
    | '/eligibility/elite'
    | '/eligibility/express'
    | '/eligibility/verified'
    | '/admin/'
    | '/borrower/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/complaints'
    | '/cookies'
    | '/eligibility'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/reset-password'
    | '/responsible-lending'
    | '/signup'
    | '/terms'
    | '/admin/borrowers'
    | '/admin/loans'
    | '/admin/login'
    | '/admin/messages'
    | '/borrower/apply'
    | '/borrower/repay'
    | '/borrower/repayment-callback'
    | '/borrower/score-callback'
    | '/eligibility/elite'
    | '/eligibility/express'
    | '/eligibility/verified'
    | '/admin'
    | '/borrower'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/borrower'
    | '/complaints'
    | '/cookies'
    | '/eligibility'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/reset-password'
    | '/responsible-lending'
    | '/signup'
    | '/terms'
    | '/admin/borrowers'
    | '/admin/loans'
    | '/admin/login'
    | '/admin/messages'
    | '/borrower/apply'
    | '/borrower/repay'
    | '/borrower/repayment-callback'
    | '/borrower/score-callback'
    | '/eligibility/elite'
    | '/eligibility/express'
    | '/eligibility/verified'
    | '/admin/'
    | '/borrower/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  BorrowerRoute: typeof BorrowerRouteWithChildren
  ComplaintsRoute: typeof ComplaintsRoute
  CookiesRoute: typeof CookiesRoute
  EligibilityRoute: typeof EligibilityRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ResponsibleLendingRoute: typeof ResponsibleLendingRoute
  SignupRoute: typeof SignupRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/borrower': {
      id: '/borrower'
      path: '/borrower'
      fullPath: '/borrower'
      preLoaderRoute: typeof BorrowerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complaints': {
      id: '/complaints'
      path: '/complaints'
      fullPath: '/complaints'
      preLoaderRoute: typeof ComplaintsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookies': {
      id: '/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof CookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eligibility': {
      id: '/eligibility'
      path: '/eligibility'
      fullPath: '/eligibility'
      preLoaderRoute: typeof EligibilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/responsible-lending': {
      id: '/responsible-lending'
      path: '/responsible-lending'
      fullPath: '/responsible-lending'
      preLoaderRoute: typeof ResponsibleLendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/borrowers': {
      id: '/admin/borrowers'
      path: '/borrowers'
      fullPath: '/admin/borrowers'
      preLoaderRoute: typeof AdminBorrowersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/loans': {
      id: '/admin/loans'
      path: '/loans'
      fullPath: '/admin/loans'
      preLoaderRoute: typeof AdminLoansRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/messages': {
      id: '/admin/messages'
      path: '/messages'
      fullPath: '/admin/messages'
      preLoaderRoute: typeof AdminMessagesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/borrower/': {
      id: '/borrower/'
      path: '/'
      fullPath: '/borrower/'
      preLoaderRoute: typeof BorrowerIndexRouteImport
      parentRoute: typeof BorrowerRoute
    }
    '/borrower/apply': {
      id: '/borrower/apply'
      path: '/apply'
      fullPath: '/borrower/apply'
      preLoaderRoute: typeof BorrowerApplyRouteImport
      parentRoute: typeof BorrowerRoute
    }
    '/borrower/repay': {
      id: '/borrower/repay'
      path: '/repay'
      fullPath: '/borrower/repay'
      preLoaderRoute: typeof BorrowerRepayRouteImport
      parentRoute: typeof BorrowerRoute
    }
    '/borrower/repayment-callback': {
      id: '/borrower/repayment-callback'
      path: '/repayment-callback'
      fullPath: '/borrower/repayment-callback'
      preLoaderRoute: typeof BorrowerRepaymentCallbackRouteImport
      parentRoute: typeof BorrowerRoute
    }
    '/borrower/score-callback': {
      id: '/borrower/score-callback'
      path: '/score-callback'
      fullPath: '/borrower/score-callback'
      preLoaderRoute: typeof BorrowerScoreCallbackRouteImport
      parentRoute: typeof BorrowerRoute
    }
    '/eligibility/elite': {
      id: '/eligibility/elite'
      path: '/elite'
      fullPath: '/eligibility/elite'
      preLoaderRoute: typeof EligibilityEliteRouteImport
      parentRoute: typeof EligibilityRoute
    }
    '/eligibility/express': {
      id: '/eligibility/express'
      path: '/express'
      fullPath: '/eligibility/express'
      preLoaderRoute: typeof EligibilityExpressRouteImport
      parentRoute: typeof EligibilityRoute
    }
    '/eligibility/verified': {
      id: '/eligibility/verified'
      path: '/verified'
      fullPath: '/eligibility/verified'
      preLoaderRoute: typeof EligibilityVerifiedRouteImport
      parentRoute: typeof EligibilityRoute
    }
  }
}

interface AdminRouteChildren {
  AdminBorrowersRoute: typeof AdminBorrowersRoute
  AdminLoansRoute: typeof AdminLoansRoute
  AdminLoginRoute: typeof AdminLoginRoute
  AdminMessagesRoute: typeof AdminMessagesRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminBorrowersRoute: AdminBorrowersRoute,
  AdminLoansRoute: AdminLoansRoute,
  AdminLoginRoute: AdminLoginRoute,
  AdminMessagesRoute: AdminMessagesRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface BorrowerRouteChildren {
  BorrowerApplyRoute: typeof BorrowerApplyRoute
  BorrowerRepayRoute: typeof BorrowerRepayRoute
  BorrowerRepaymentCallbackRoute: typeof BorrowerRepaymentCallbackRoute
  BorrowerScoreCallbackRoute: typeof BorrowerScoreCallbackRoute
  BorrowerIndexRoute: typeof BorrowerIndexRoute
}

const BorrowerRouteChildren: BorrowerRouteChildren = {
  BorrowerApplyRoute: BorrowerApplyRoute,
  BorrowerRepayRoute: BorrowerRepayRoute,
  BorrowerRepaymentCallbackRoute: BorrowerRepaymentCallbackRoute,
  BorrowerScoreCallbackRoute: BorrowerScoreCallbackRoute,
  BorrowerIndexRoute: BorrowerIndexRoute,
}

const BorrowerRouteWithChildren = BorrowerRoute._addFileChildren(
  BorrowerRouteChildren,
)

interface EligibilityRouteChildren {
  EligibilityEliteRoute: typeof EligibilityEliteRoute
  EligibilityExpressRoute: typeof EligibilityExpressRoute
  EligibilityVerifiedRoute: typeof EligibilityVerifiedRoute
}

const EligibilityRouteChildren: EligibilityRouteChildren = {
  EligibilityEliteRoute: EligibilityEliteRoute,
  EligibilityExpressRoute: EligibilityExpressRoute,
  EligibilityVerifiedRoute: EligibilityVerifiedRoute,
}

const EligibilityRouteWithChildren = EligibilityRoute._addFileChildren(
  EligibilityRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  BorrowerRoute: BorrowerRouteWithChildren,
  ComplaintsRoute: ComplaintsRoute,
  CookiesRoute: CookiesRoute,
  EligibilityRoute: EligibilityRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ResponsibleLendingRoute: ResponsibleLendingRoute,
  SignupRoute: SignupRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
